const sum = numbers => numbers.reduce((sum, next) => sum + next);

export default sum;
